import PasswordReset from '../../pages/PasswordReset'
import { usePasswordReset } from '../../hooks/usePasswordReset'

function PasswordResetWrapper(props) {
  const { processed, error, disabledForm, submit } = usePasswordReset()

  return (
    <PasswordReset
      siteKey={props.siteKey || ''}
      processed={processed}
      error={error}
      disabledForm={disabledForm}
      onSubmit={submit}
      onExecuteRecaptcha={() => {}}
    />
  )
}

export default PasswordResetWrapper
